import { context } from "../../components/wr-context";
export var fetchCompanySettingsRequest = function(companyId) {
    return {
        url: "".concat(context.constants.appHost, "/api/v2/settings/").concat(companyId)
    };
};
